'use strict';

angular.module('ClinicApp').directive('switchery', function($window, $timeout) {
  return {
    require: 'ngModel',
    scope: {
      checked: '=ngModel',
      mini: '=switcheryMini',
    },
    link: function($scope, element, _$attrs, ngModel) {
      var className = 'switchery' + ($scope.mini ? ' mini' : '');

      $timeout(function() {
        var switchery = new $window.Switchery(element[0], {
          color: '#80AAA5',
          className: className,
        });
        var input = switchery.element;

        // Set initial state.
        input.checked = $scope.checked;
        switchery.setPosition();

        // Update model after changing checkbox state.
        input.addEventListener('change', function() {
          $scope.$apply(function() {
            ngModel.$setViewValue(input.checked);
          });
        });

        // Keep track of proper position of the switcher
        // if the model is changed from controller for example.
        $scope.$watch('checked', function() {
          switchery.setPosition();
        });
      }, 0);
    },
  };
});
